import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  fill: "none",
  viewBox: "0 0 18 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "M3.75 15.75q-.619 0-1.059-.44a1.45 1.45 0 0 1-.441-1.06V3.75q0-.619.441-1.059T3.75 2.25h4.5q.319 0 .535.216A.72.72 0 0 1 9 3q0 .318-.216.535a.72.72 0 0 1-.534.215h-4.5v10.5h10.5v-4.5q0-.319.216-.534A.73.73 0 0 1 15 9q.318 0 .535.216a.72.72 0 0 1 .215.534v4.5q0 .619-.44 1.06a1.44 1.44 0 0 1-1.06.44zM14.25 4.8 7.8 11.25a.71.71 0 0 1-.525.206.71.71 0 0 1-.525-.206.71.71 0 0 1-.206-.525q0-.319.206-.525l6.45-6.45h-1.95a.72.72 0 0 1-.534-.216A.73.73 0 0 1 10.5 3q0-.318.216-.534a.73.73 0 0 1 .534-.216H15q.319 0 .535.216A.72.72 0 0 1 15.75 3v3.75q0 .318-.216.535A.72.72 0 0 1 15 7.5a.73.73 0 0 1-.534-.216.72.72 0 0 1-.216-.534z"
    }, null, -1)
  ]))]))
}
export default { render: render }